import styled from '@xstyled/styled-components';
import React, { FC, useEffect } from 'react';
import { select } from '~/lib/select';
import { Bar } from '~/training/progress-bar/ProgressBar.styles';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { ItemOfType } from '../../translators/itemHelpers/types';
import { QuizInstaComponentButton } from './QuizInstaComponentButton';
import {
  SequenceStore,
  useSequenceStore
} from '~/training/sequence/SequenceStore';

const QuizInstaComponentWrapper = styled.div`
  width: 95%;
  bottom: 70px;
  position: absolute;
  left: 2.5%;
  z-index: 3;
`;

const QuizInstaComponentButtons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
`;

const selector = (s: MediaPlayerStore) => select(s, 'progress');

const sequenceSelector = (s: SequenceStore) => select(s, 'addBlocker');

export const QuizInstaComponent: FC<{
  id: string;
  questions: ItemOfType<'Question'>['items'];
  setQuestionAnswered: (state: boolean) => void;
  isVideoFinished: boolean;
  setVideoFinished: (state: boolean) => void;
}> = ({
  id,
  questions,
  isVideoFinished,
  setVideoFinished,
  setQuestionAnswered
}) => {
  const { progress } = useMediaPlayerStore(selector);
  const { addBlocker } = useSequenceStore(sequenceSelector);

  useEffect(() => {
    if (!isVideoFinished && progress === 1) {
      setVideoFinished(true);
    }
  }, [progress]);

  useEffect(() => addBlocker(id), []);

  return (
    <QuizInstaComponentWrapper aria-live="polite">
      {isVideoFinished ? (
        <>
          <QuizInstaComponentButtons>
            {questions?.map(question => {
              const feedbackAudios: {
                mediaUrl: string;
                subtitlesUrl: string;
              } | null =
                question.feedbackAudios &&
                question.feedbackAudios.length > 0 &&
                question.feedbackAudios[0].mediaUrl
                  ? {
                      mediaUrl: question.feedbackAudios[0].mediaUrl,
                      subtitlesUrl:
                        question.feedbackAudios[0].subtitlesUrl || ''
                    }
                  : null;

              return (
                <React.Fragment key={question.id}>
                  <QuizInstaComponentButton
                    id={question.id}
                    group={id}
                    feedback={question?.feedback!}
                    feedbackAudios={feedbackAudios}
                    setQuestionAnswered={setQuestionAnswered}
                    correct={question.correct!}
                  >
                    {question.value}
                  </QuizInstaComponentButton>
                </React.Fragment>
              );
            })}
          </QuizInstaComponentButtons>
        </>
      ) : (
        <Bar>
          <Bar bg="white" opacity="0.4" />
          <Bar
            bg="white"
            w={`${(progress * 100).toString().slice(0, 4)}%`}
            marginTop="-4px"
          />
        </Bar>
      )}
    </QuizInstaComponentWrapper>
  );
};
